import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData } from "../../../services/api";
import { hideAddArticleModal } from "./articleModalDispatcher";

/**
 * ADD / UPDATE ARTICLE
 */
export const addArticleRequest = (data) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_ARTICLE_REQUEST" });

    try {
      const response = data.id
        ? await updateData(data, `${ApiURLs.ARTICLE}/${data.id}`)
        : await postData(data, ApiURLs.ARTICLE);

      if (response.status === 1) {
        dispatch({ type: "ADD_ARTICLE_SUCCESS" });
        dispatch(hideAddArticleModal());

        // Refresh listing
        dispatch(articleListingRequest());
      } else {
        dispatch({ type: "ADD_ARTICLE_FAILED" });
      }
    } catch (error) {
      console.log("Error in add/update article:", error);
      dispatch({ type: "ADD_ARTICLE_FAILED" });
    }
  };
};

/**
 * GET ARTICLE LIST (PAGINATION FIXED)
 */
export const articleListingRequest = (page = 1, pageSize = 50) => {
  return async (dispatch) => {
    dispatch({ type: "GET_ARTICLE_REQUEST" });

    try {

      const url = `${ApiURLs.ARTICLE}?offset=${page}&limit=${pageSize}`;

      const res = await fetchData(url);

      if (res.status === 1) {
        dispatch({
          type: "GET_ARTICLE_REQUEST_SUCCESS",
          payload: res.data.result,
          total: res.data.total,
        });
      } else {
        dispatch({ type: "GET_ARTICLE_REQUEST_FAILED" });
      }
    } catch (error) {
      console.log("Error fetching articles:", error);
      dispatch({ type: "GET_ARTICLE_REQUEST_FAILED" });
    }
  };
};

// articleApi.js (or same file)
export const getArticle = async (id) => {
  try {
    const res = await fetchData(`${ApiURLs.ARTICLE}?id=${id}`);

    if (res.status === 1) {
      return res.data.result[0] || null; // ✅ return single object
    }

    return null;
  } catch (error) {
    console.log("Error fetching article detail:", error);
    return null;
  }
};

/**
 * SIMPLE GET LIST (WITHOUT REDUX - UTILITY)
 */
export const getArticleListing = () => {
  return async () => {
    try {
      const res = await fetchData(ApiURLs.ARTICLE);

      if (res.status === 1) {
        return res.data.result;
      } else {
        return [];
      }
    } catch (error) {
      console.log("Error fetching article list:", error);
      return [];
    }
  };
};

/**
 * DELETE ARTICLE
 */
export const deleteArticle = (id) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_ARTICLE_REQUEST" });

    try {
      const res = await deleteData(`${ApiURLs.ARTICLE}/${id}`);

      if (res.status === 1) {
        dispatch({ type: "ADD_ARTICLE_SUCCESS" });

        // Refresh list
        dispatch(articleListingRequest());
      } else {
        dispatch({ type: "ADD_ARTICLE_FAILED" });
      }
    } catch (error) {
      console.log("Error deleting article:", error);
      dispatch({ type: "ADD_ARTICLE_FAILED" });
    }
  };
};

// articleApi.js (or same file)
export const getArticleCategories = async () => {
  try {
    const res = await fetchData(ApiURLs.ARTICLE_CATEGORIES);

    if (res.status === 1) {
      return res.data.result; // ✅ direct return
    }

    return [];
  } catch (error) {
    console.log("Error fetching categories:", error);
    return [];
  }
};